import * as React from 'react';
import { observer } from 'mobx-react';
import { action, observable, makeObservable } from 'mobx';
import { MembershipPlanIndexView, MembershipPlanKey } from '../../../../types/membershipPlans';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { EntranceFeeShowView } from '../../../../types/entranceFees';
import { MembershipPlanApis } from '../../../../apis/membershipPlans';
import { EntranceFeeApis } from '../../../../apis/entranceFees';
import { LoaderRow } from '../../../atoms/layout/LoaderRow';
import { PlanView } from './PlanSelector';
import './pricingSummary.module.scss';
import { SimpleEntranceFeeView } from './SimpleEntranceFeeView';

type Props = {
  styleName?: string;
  className?: string;
};

export const PricingSummary = observer(
  class PricingSummary extends React.Component<Props> {
    selectedKey = MembershipPlanKey.REGULAR;
    plans: RemoteResourceV3<MembershipPlanIndexView[]> = RemoteResourceV3.loading();
    entranceFee: RemoteResourceV3<EntranceFeeShowView> = RemoteResourceV3.loading();

    constructor(props: Props) {
      super(props);

      makeObservable(this, {
        selectedKey: observable,
        plans: observable,
        entranceFee: observable,
        init: action.bound,
      });
    }

    componentDidMount(): void {
      this.init();
    }

    async init() {
      await Promise.all([
        updateRemoteResourceV3(
          this.plans,
          (v) => (this.plans = v),
          () => MembershipPlanApis.findAll(true)
        ),
        updateRemoteResourceV3(
          this.entranceFee,
          (v) => (this.entranceFee = v),
          () => EntranceFeeApis.show(true)
        ),
      ]);
    }
    render() {
      const { className } = this.props;
      return (
        <div styleName="summary" className={className}>
          <div styleName="intro-text">
            SHEでは、全レッスン受け放題の『受け放題プラン』と月に5回までレッスンを受講できる『月5回プラン』の2つのプランがあります。
          </div>
          {(this.plans.loading || this.entranceFee.loading) && <LoaderRow />}
          <PlanView
            selectedKey={this.selectedKey}
            onSelectKeyChange={(key) => (this.selectedKey = key)}
            plans={this.plans.getOrElse([])}
          />
          <SimpleEntranceFeeView
            price={this.entranceFee.map((e) => e.price).getOrElse(0)}
            price_with_tax={this.entranceFee.map((e) => e.price_with_tax).getOrElse(0)}
          />
        </div>
      );
    }
  }
);
